import { CTModelDatatableFilter } from "@ctsolution/ct-framework";
import { EventPathParam } from "../../../_core/classes/event-path-param";

export class TaskListConfiguration {

  onlyUpdate = false;
  extraUrlParam: string | null = null;
  navigatePostAction = true;
  param: EventPathParam | null = null;
  constructor(public Filters: Array<CTModelDatatableFilter> | null = null, public Action: ((event: any) => void) | null = null) { }

  setAction(value: ((event: any) => void) | null = null): TaskListConfiguration {

    this.Action = value;
    return this;

  }

  setOnlyUpdate(value: boolean): TaskListConfiguration {

    this.onlyUpdate = value;
    return this;

  }

  setExtraUrlParam(value: string): TaskListConfiguration {

    this.extraUrlParam = value;
    return this;

  }

  setNavigatePostAction(value: boolean): TaskListConfiguration {

    this.navigatePostAction = value;
    return this;

  }

  setParam(value: EventPathParam): TaskListConfiguration {

    this.param = value;
    return this;

  }

}
export class TaskListParam{

    constructor(public oidWorkOrder: number | null = null, public extraUrlParam: string | null = null) { }

}